import { HttpInterceptorFn } from '@angular/common/http';
import { LocalStorageService } from '../services/localStorage/local-storage.service';
import { inject } from '@angular/core';

export const authInterceptor: HttpInterceptorFn = (req, next) => {
  const localStorageService = inject(LocalStorageService);
  const token = localStorageService.getAuthToken();

  // Skip adding token for login and other public endpoints
  const publicEndpoints = ['auths/signin', 'auths/forgotPassword', 'auths/verify', 'auths/resend'];
  const isPublicEndpoint = publicEndpoints.some(endpoint => req.url.includes(endpoint));

  if (token && !isPublicEndpoint) {

    const isFormData = req.body instanceof FormData;
    const authReq = req.clone({
      setHeaders: {
        'x-access-token': token,
        ...(isFormData ? {} : { 'Content-Type': 'application/json' })
      }
    });
    return next(authReq);
  }

  return next(req);
};
